import { React, useEffect, useState } from 'react';
import GeoGebraMySolAnimation from '../components/GeoGebraMySolAnimation';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

const LevelProblemMySolAnimation = ()=> {
    const navigateto=useNavigate();
    const {levelProblemMyID}=useParams();
    const {ListInLevel, levelURL, problemCode, problemOrder, problem, useStat, isFirst, isLast, prevProblem, prevOrder, nextProblem, nextOrder, myAnswerList, myPointConstruction, myConstructionStep, myAnswerRaw} = useLocation().state;
    const [randomString1, setRandomString1] = useState();

    useEffect(() => {
        const revivalData = () => {
            const letters = '1234567890';
            let randomString1l = '';
            for (let i = 0; i < 3; i++) {
                randomString1l += letters[Math.floor(Math.random() * letters.length)];
            }
            setRandomString1(randomString1l);
        };
        revivalData();
    },[levelProblemMyID])

    return(
        <div className="problem" key={myAnswerRaw.answerMark}>
            <div className="content-fit">
                <h4>{myAnswerRaw.solvingTime.substring(6,10)}년 {myAnswerRaw.solvingTime.substring(3,5)}월 {myAnswerRaw.solvingTime.substring(0,2)}일 {myAnswerRaw.solvingTime.substring(12,17)}의 풀이</h4>
                <GeoGebraMySolAnimation
                    idIn={problem.problemCode}
                    customToolBarIn={problem.customToolBar}
                    allowStyleBarIn={problem.allowStyleBar}
                    ggbBase64In={problem.problemContent}
                    myPointAnswer={myPointConstruction}
                    myAnswerStep={myConstructionStep}
                    problemType={problem.problemType}
                />
                <div className='horizontal-flex-container'>
                    {/* {isFirst 
                        ? null 
                        : <button 
                            className='button' 
                            onClick={() => navigateto(`/problem/level/problem/${prevOrder}`, {state:{
								"ListInLevel": ListInLevel,
								"levelURL": levelURL,
								"problemCode": prevProblem,
								"problemOrder": prevOrder
                            }})}
                        >
                            이전 문제
                        </button>
                    } 
                    {isLast 
                        ? null 
                        : <button 
                            className='button' 
                            onClick={() => navigateto(`/problem/level/problem/${nextOrder}`, {state:{
								"ListInLevel": ListInLevel,
								"levelURL": levelURL,
								"problemCode": nextProblem,
								"problemOrder": nextOrder
                            }})}
                        >
                            다음 문제
                        </button>
                    }
                    <button 
                        className='button'
                        onClick={() => navigateto(`/problem/level/problem/${problemOrder}`, {state:{
							"ListInLevel": ListInLevel,
							"levelURL": levelURL,
							"problemCode": problemCode,
							"problemOrder": problemOrder
                        }})}
                    >
                        문제로 돌아가기
                    </button> */}
                    <button 
                        className='button'
                        onClick={() => navigateto(`/problem/level/problem/my/${levelProblemMyID}`, {state:{
                            "ListInLevel": ListInLevel,
							"levelURL": levelURL,
							"problemCode": problemCode,
							"problemOrder": problemOrder,
							"problem": problem,
							"useStat": useStat,
							"isFirst": isFirst,
							"isLast": isLast,
							"prevProblem": prevProblem,
							"prevOrder": prevOrder,
							"nextProblem": nextProblem,
							"nextOrder": nextOrder,
							"myAnswerList": myAnswerList
                        }})}
                    >
                        풀이 보기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LevelProblemMySolAnimation;
